module.exports = __webpack_public_path__ + "img/2.08df3b30.png";